import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { useTranslation } from 'next-i18next';

import { useCollateralToken } from '../../TradeModule/store/useCollateralToken';
import { useIsLong } from '../../TradeModule/store/useIsLong';

export const useOpenMarketTradeToastOpts = () => {
  const { t } = useTranslation();
  const selectedTradingPair = useTradingPair((s) => s.useTradingPair());
  const isLong = useIsLong((s) => s._persistValue);
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());
  const inputAmount = useFromInput((s) => s.input).value.token;

  return {
    onMutateToastOpts: {},
    onMutateToastOptsOneClick: {
      title: 'In Progress',
      description: '⚡️ One-click trade in progress',
    },
    onSuccessToastOpts: {
      description: t(
        'common.Paid {payTokenAmount} {payTokenSymbol} to {tradeType} {tokenPair}',
        {
          tokenPair: `${selectedTradingPair?.baseName}`,
          tradeType: isLong ? 'Long' : 'Short',
          payTokenSymbol: payToken?.displaySymbol,
          payTokenAmount: inputAmount,
          interpolation: {
            escapeValue: false,
          },
        },
      ),
    },
    onSuccessToastOptsOneClick: {
      title: '⚡️ Completed',
      description: t(
        'common.Paid {payTokenAmount} {payTokenSymbol} to {tradeType} {tokenPair}',
        {
          tokenPair: `${selectedTradingPair?.baseName}`,
          tradeType: isLong ? 'Long' : 'Short',
          payTokenSymbol: payToken?.displaySymbol,
          payTokenAmount: inputAmount,
          interpolation: {
            escapeValue: false,
          },
        },
      ),
    },
    onErrorToastOpts: {},
    onErrorToastOptsOneClick: {
      description: 'One-click trade failed, please try again',
    },
  };
};
